import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminBroadcast() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/admin/broadcast").then((r) => setList(r.data)); }, []);

  const exportCsv = async () => {
    const token = localStorage.getItem("furshala_admin_token");
    const r = await fetch(`${api.defaults.baseURL}/admin/broadcast/export`, { headers: { Authorization: `Bearer ${token}` } });
    const blob = await r.blob();
    const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = "furshala-broadcast.csv"; a.click();
  };

  return (
    <div data-testid="admin-broadcast">
      <div className="flex justify-between items-end mb-8 flex-wrap gap-4">
        <div>
          <h1 className="font-serif text-3xl text-brand-soft">WhatsApp broadcast</h1>
          <p className="text-sm text-brand-soft/60 mt-1">Folks who opted in via the community page.</p>
        </div>
        <button onClick={exportCsv} className="btn-outline-furshala inline-flex items-center gap-2 text-sm py-2"><Download className="w-4 h-4" /> Export CSV</button>
      </div>

      <div className="bg-white rounded-2xl border border-brand-maroon/10 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-brand-ivory text-brand-soft/70">
            <tr>
              <th className="text-left px-4 py-3 text-xs uppercase tracking-widest font-medium">Name</th>
              <th className="text-left px-4 py-3 text-xs uppercase tracking-widest font-medium">Phone</th>
              <th className="text-left px-4 py-3 text-xs uppercase tracking-widest font-medium">Joined</th>
            </tr>
          </thead>
          <tbody>
            {list.length === 0 && <tr><td colSpan={3} className="p-8 text-center text-brand-soft/60 italic">No signups yet.</td></tr>}
            {list.map((s) => (
              <tr key={s.id} className="border-t border-brand-maroon/5">
                <td className="px-4 py-3">{s.name}</td>
                <td className="px-4 py-3">{s.phone}</td>
                <td className="px-4 py-3 text-xs text-brand-soft/60">{new Date(s.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
